export default "__VITE_ASSET__BzeXNfhU__"